enum userTypeEnum {
  SuperAdministrator = 0,
  DIDManager = 1,
  FactoryAdmin = 2,
  FactoryManager = 3,
  ProductMaster = 4,
  FactoryProductionManager = 5,
  Operator = 6,
}

export default userTypeEnum;
